import { Component, Input, Inject, EventEmitter, Output, forwardRef } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';


@Component({
  selector: 'app-siteinfoimageupload',
  templateUrl: './siteinfoimageupload.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SiteInfoImageUploadComponent),
      multi: true
    }
  ]
})


export class SiteInfoImageUploadComponent implements ControlValueAccessor {


 
  value: any = null;
  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // optional
  }

 

  myFile: any = { "Filename": "", "Title": "", "Type": "" };

  // myLargeFiles: any = [];
  maxFileSize = 40 * 1024 * 1024;
  dspTooLarge = false;

  bytesToMB(bytes: number): number {
    const megabytes = bytes / (1024 * 1024); // Convert bytes to MB
    return Math.round(megabytes); // Round to 0 decimal places
  }

  //myFile = { "Filename": "", "Title": "", "Type": "" }; //clear this out each time
  dspUploadPending = false;

  myFiles: string[] = [];
  myFilesPreview: any = [];
  //fileData: File = null;
  myMimeTypes = [""
    , "image/jpeg"
    , "image/png"
    , "video/webp"
  ]

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
        if ((encoded.length % 4) > 0) {
          encoded += '='.repeat(4 - (encoded.length % 4));
        }
        resolve({ "Clean": encoded, "Meta": reader.result.toString() });
      };
      reader.onerror = error => reject(error);
    });
  }


  getFileSizes() {

    this.dspTooLarge = false;
    let myFilesCombinedSize = 0;
    this.myFilesPreview.forEach((itm: any) => {
      myFilesCombinedSize += itm.Size;
    });

    if (myFilesCombinedSize > this.maxFileSize) {
      this.dspTooLarge = true;

    }

  }

  handleFileInput(event: any) { //this one for the fiel select// could deal with multiple files (restricted by input)

    this.myFiles = [];

    // this.myLargeFiles = []

    let myFilesCombinedSize = 0;

    for (let x: number = 0; x < event.target.files.length; x++) {
      //preview // we want to encourage the upload so no preview
      let fileData: File = <File>event.target.files[x];
      let mimeType: string = fileData.type;

      let myFile = null;

      if (this.myMimeTypes.findIndex(x => x === mimeType) > -1) {

        // myFilesCombinedSize += fileData.size

        //if (fileData.size > this.maxFileSize) {
        //   this.myLargeFiles.push(fileData.name);
        //}

        //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size / 1024+ 'MB' });

        // if (myFilesCombinedSize > this.maxFileSize) {
        //this.myLargeFiles.push({ "file": fileData.name, "size": fileData.size });
        //  this.dspTooLarge = true
        //}

        this.getBase64(fileData).then(
          (data: any) => {
            if (mimeType.match(/image\/*/) == null) {
              myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size, "Type": event.target.files[x].type, "File": "", "Base64": data.Clean, "Display": "File" };
            }
            else {
              myFile = { "Filename": event.target.files[x].name, "Title": event.target.files[x].name, "Size": event.target.files[x].size, "Type": event.target.files[x].type, "File": data.Meta, "Base64": data.Clean, "Display": "Image" };
            }
            this.myFilesPreview.push(myFile);

            this.getFileSizes()
          }
        );



      }
      else {
        return;//nothing
      }



    }




    this.dspUploadPending = true;
  }



  



  public change() {
    const input = document.querySelector('input');
    const file = input.files[0];

    this.getBase64(file).then(base64 => {
      const img = new Image();
      img.onload = () => console.log(img.width, img.height);
      img.src = base64.toString();
    });
  }




  ngOnInit() {

  }


}
